module.exports = __webpack_public_path__ + "img/logo_login.2186d658.png";